import { render, staticRenderFns } from "./VDaterange.vue?vue&type=template&id=4d53a78a"
import script from "./VDaterange.vue?vue&type=script&lang=js"
export * from "./VDaterange.vue?vue&type=script&lang=js"
import style0 from "./VDaterange.vue?vue&type=style&index=0&id=4d53a78a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports